import React from 'react';
import SvgLoanding from './../atoms/SvgLoading.jsx'
import './../styles/SvgLoading.scss'

const SectionLoadingLoader = () => (
    <div className="contentLoader">
        < SvgLoanding />
    </div>
)

export default SectionLoadingLoader;